import { useGetWorkTemplateCreateData } from 'ogp/hooks/queryHooks/jobs/use-get-work-template-create-data';
import { RenderUnsettledUI } from 'shared/components';
import { useParams } from 'react-router-dom';
import { useGetCompanyEmploymentTypes, useGetWorkTemplate } from 'api';
import { useSiteDetection } from 'shared/hooks';
import { invariant } from 'shared/utils/utils';
import { WorkTemplateCreatePage } from './work-template-create-page';
import { workTemplateAlerts } from '../../../../../../../shared/components/alerts';
import { encodeWorkTemplateToWorkTemplateForm } from '../utils';

export const WorkTemplateDuplicateDataProvider = () => {
  const { id } = useParams<'id'>();
  invariant(id, 'Job ID must be defined');

  const { site } = useSiteDetection();
  const jobQuery = useGetWorkTemplate(site, id, !!id);
  const workTemplateCreateDataQuery = useGetWorkTemplateCreateData();
  const employmentType = useGetCompanyEmploymentTypes(site);

  if (workTemplateCreateDataQuery.status !== 'success') {
    return <RenderUnsettledUI data={workTemplateCreateDataQuery} />;
  }

  if (jobQuery.status !== 'success') {
    return <RenderUnsettledUI data={jobQuery} />;
  }

  if (employmentType.status !== 'success') {
    return <RenderUnsettledUI data={employmentType} />;
  }

  const defaultValues = encodeWorkTemplateToWorkTemplateForm(jobQuery.data);

  return (
    <WorkTemplateCreatePage
      workTemplateCreateData={workTemplateCreateDataQuery.data}
      pageTitle={`Functie ${defaultValues.workName} dupliceren`}
      defaultValues={defaultValues}
      successMessage={workTemplateAlerts.success.created}
      employmentType={employmentType.data}
    />
  );
};
